<template>
  <div class="mandati">
    <gnetHeader></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="$store.getters.appname"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    />

 



    <div class="slds-grid">
      <div v-bind:class="{ 'slds-col slds-size_2-of-3': showTimeline, 'slds-col slds-size_11-of-12': !showTimeline }">

        <gnetRecordHeader
          v-bind:object="'account'"
          v-bind:title="title"
          
          v-bind:fields="headlineFields"
          v-bind:actions="headlineActions"
          v-on:click="actionClick($event)"
        />

        <gnetTabs v-if="!listmode" v-bind:tabs="$store.state.campagne" v-on:change="changeCampagna($event)">
          <template v-slot:main>
            <gnetTable
              v-bind:cols="ordinicols"
              v-bind:records="ordini"
              v-on:click="click($event)"
              v-on:filter="filter($event)"
            ></gnetTable>
          </template>
        </gnetTabs>

        <template v-if="listmode" >

            <div style="background-color: white;" >

              <gnetFormMask v-on:click="listcredito=!listcredito; campipartite[0].opened=listcredito" v-bind:sections="campipartite" ></gnetFormMask>
              <gnetTable 
                v-if="listcredito"
                v-bind:cols="partitecols"
                v-bind:records="partite"
                v-on:click="click($event)"
                v-on:filter="filter($event)"></gnetTable>
            </div>

              <gnetModal
                v-if="filterPanel.show"
                v-bind:title="'Filtro ' + filterPanel.colName"
                v-on:cancel="filterPanel.show = false"
                v-on:submit="applyFilter"
              >
                <div class="slds-form-element">
                  <label class="slds-form-element__label" for="filter-input">Testo da cercare:</label>
                  <div class="slds-form-element__control">
                    <input 
                      v-model="filterPanel.value" 
                      type="text" 
                      id="filter-input" 
                      class="slds-input" 
                      autofocus
                    />
                  </div>
                </div>
              </gnetModal>
            <gnetExpandable v-on:click="listdocumenti=!listdocumenti" v-bind:title="'Documenti'" v-bind:actions="documentiActions" v-on:change="actionClick($event)" v-bind:opened='listdocumenti'>
              <gnetTable
                v-bind:cols="documenticols"
                v-bind:records="filteredDocumenti"
                v-bind:tooltipsValue="mappaTooltips"
                v-on:click="click($event)"
                v-on:filter="(index) => openFilterPanel(index, 'documenti')"
                v-on:requestTooltipData="deliveryTooltipData"
              ></gnetTable>
            </gnetExpandable>

            <gnetExpandable v-on:click="listordini=!listordini" v-bind:title="'Ordini'" v-bind:opened='listordini' v-bind:actions="ordiniActions" v-on:change="actionClick($event)">
              <gnetTabs v-bind:tabs="$store.state.campagne" v-on:change="changeCampagnaOrdini($event)" v-bind:multi="true" v-bind:multidefault="filtrocampagneO">
                <template v-slot:main>
                  <gnetTable
                    v-bind:cols="ordinidetailcols"
                    v-bind:records="ordinidetail"
                    v-on:click="click($event)"
                    v-on:filter="filter($event)">
                  </gnetTable>
                </template>
              </gnetTabs>
            </gnetExpandable>

            <gnetExpandable v-on:click="listfatture=!listfatture" v-bind:title="'Fatture'" v-bind:opened='listfatture' v-bind:actions="fattureActions" v-on:change="actionClick($event)">
              <gnetTabs v-bind:tabs="$store.state.campagne" v-on:change="changeCampagnaFatture($event)" v-bind:multi="true" v-bind:multidefault="filtrocampagneF">
                <template v-slot:main>
                  <gnetTable
                    v-bind:cols="fatturecols"
                    v-bind:records="filteredFatture"
                    v-on:click="click($event)"
                    v-on:filter="(index) => openFilterPanel(index, 'fatture')"
                  ></gnetTable>
                </template>
              </gnetTabs>
            </gnetExpandable>

            <gnetExpandable v-on:click="listquotazioni=!listquotazioni" v-bind:title="'Quotazioni'" v-bind:opened='listquotazioni' v-bind:actions="quotazioniActions" v-on:change="actionClick($event)">
              <gnetTable
                v-bind:cols="quotazionicols.filter( c => c.type != 'hidden')"
                v-bind:records="quotazioni"
                v-on:click="click($event)"
              ></gnetTable>
            </gnetExpandable>


            <!-- SEZIONE B2B -->
            <div style="background-color: white;" >

              <gnetFormMask v-on:click="b2bsection=!b2bsection; B2Bcampi[0].opened=b2bsection" v-bind:sections="B2Bcampi" ></gnetFormMask>
              <gnetTable 
                v-if="b2bsection"
                v-bind:cols="B2Bcols"
                v-bind:records="B2Bcontacts"></gnetTable>
            </div>

        </template>
      </div>

    <button v-on:click="showTimeline=!showTimeline" class="slds-button slds-button_icon slds-button_icon bottonesplit" aria-controls="split-view-id" aria-expanded="false" title="Open Split View">
      <svg class="slds-button__icon slds-button__icon_x-small" aria-hidden="true">
        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#right"></use>
      </svg>
      <span class="slds-assistive-text">Open Split View</span>
    </button>


        <div v-if="showTimeline" class="slds-col slds-size_1-of-3">
        <gnetRecordHeader
          v-bind:object="'task'" 
          v-bind:title="'Attività'" 
          v-bind:actions="timelineActions"
          v-on:click="actionClick($event)"
        />
        <gnetTimeline v-bind:records="timeline"></gnetTimeline>
      </div>

        <div v-if="!showTimeline" class="slds-col slds-size_1-of-12">
        <gnetRecordHeader 
          v-bind:object="'task'" 
          v-bind:title="'Attività'" 
        />
      </div>

    </div>

    <pdfmake v-if="showpdf" v-bind:campagne="filtrocampagneF" v-bind:codicecliente="record.Codice_2019__c" v-bind:nascondilinee="showpdfnolinee" v-on:change="showpdf=false"></pdfmake>
    <pdfmakeordini v-if="showpdfordini" v-bind:campagne="filtrocampagneO" v-bind:codicecliente="record.Codice_2019__c" v-bind:nascondilinee="showpdfnolinee" v-on:change="showpdfordini=false"></pdfmakeordini>

    <qualifica v-if="showQualifica" v-bind:newcustomer="false" v-bind:dati="dati" v-on:cancel="showQualifica=false" v-on:change="setField($event)" v-on:submit="updateAccount" ></qualifica>

    <moduloassegni v-if="showAssegni" v-on:submit="saveAssegni" v-on:cancel="showAssegni=false" v-bind:recordId="recordId" ></moduloassegni>
    <gnetActivity v-show="editTask" v-on:save="saveTask($event)" v-on:cancel="editTask=false" />
    <gnetB2B v-if="record.B2B_Active__c" v-bind:email="record.Email__c" v-show="b2b" v-on:save="saveB2B($event)" v-on:cancel="b2b=false" />
    
    <gnetTicket v-bind:fields="ticketfields" v-show="editTicket" v-on:change="setTicketField($event)" v-on:submit="saveTicketFd" v-on:cancel="editTicket=false" />

    <gnetSpinner v-bind:busy="busy"></gnetSpinner>

  </div>
</template>

<script>

// @ is an alias to /src
// import numeral from 'numeral'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import gnetRecordHeader from '../components/recordheader.vue'
import gnetTimeline from '../components/timeline.vue'
import gnetTable from '../components/table.vue'
import gnetSpinner from '../components/spinner.vue'
import gnetTabs from '../components/tabs.vue'
import apiclient from '@/apiclient.js'
import gnetMixLib from '@/mixin.js'
import gnetActivity from '../components/activity.vue'
import gnetB2B from '../components/b2b.vue'
import moduloassegni from '../components/moduloassegni.vue'
import gnetTicket from '../components/ticket.vue'
import qualifica from '../components/qualifica.vue'
import moment from 'moment'
import mustache from 'mustache'
import gnetExpandable from '../components/expandable.vue'
import gnetFormMask from '../components/formmask.vue'
import pdfmake from '../components/fatturepdf.vue'
import pdfmakeordini from '../components/ordinipdf.vue'
import gnetModal from '../components/modal.vue';
import tooltip from '../components/tooltip.vue';


export default {
  name: 'CustomerForm',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    gnetRecordHeader,
    gnetTimeline,
    gnetTable,
    gnetTabs,
    gnetSpinner,
    gnetActivity,
    gnetB2B,
    moduloassegni,
    gnetTicket,
    gnetExpandable,
    gnetFormMask,
    qualifica,
    pdfmake,
    pdfmakeordini,
    gnetModal,
    tooltip
  },
  data: function() {
    return {
      showpdfordini: false,
      showpdf: false,
      showpdfnolinee: false,
      showTimeline: true,
      listordini: false,
      listfatture: true,
      listcredito: false,
      listdocumenti: false,
      listquotazioni: false,
      b2bsection: false,

      listmode: true,

      busy: false,
      recordId:'',
      record: {},
      create:false,

      filtrocampagneO:[true,false,false,false,false,false,false,false,false,false,false,false,],
      filtrocampagneF:[false,false, false,false,false,false,true,false,true,false,false,false,false,],
      filtrocampagneQ:[true,false, false,false,false,false,false,false,false,false,false,false,false,],
      ticketfields:[],
      ticketLastCreated:'',

      tickets:[],
      tasks:[],

      campagna:'',

      linee:[],

      ordinicols:[],
      ordini:[],

      partitecols:[],
      partite:[],
      campipartite:[],

      B2Bcampi: [],
      B2Bcols: [],
      B2Bcontacts: [],

      documenticols:[],
      documenti:[],
      ordiniCompleti:[],
      fattureComplete:[],

      fatturecols:[],
      fatture:[],
      campifatture:[],

      ordinidetailcols:[],
      ordinidetail:[],
      campiordinidetail:[],

      quotazionicols: [
        { order: 0, value:'', label:'Id', name:'Id', type:'hidden' },
        { order: 1, value:'', label:'#', name:'Name', type:'string' },
        { order: 2, value:'', label:'Cliente', name:'Account__r.Name', type:'string' },
        // { order: 3, value:'', label:'Anno Campagna', name:'AnnoCampagna__c', type:'string' },
        { order: 3, value:'', label:'Data creazione', name:'CreatedDate', type:'date' },
        { order: 4, value:'', label:'Prezzo Totale', name:'Prezzo_Totale__c', type:'currency' }
      ],

      fields:[],
      fieldsstring: '',
      headlineFields: [],
      documentiActions: [  ],
      ordiniActions: [ {title: 'Genera Pdf No Linee', name:'generapdfordininolinee', symbol:'task'}, {title: 'Genera Pdf', name:'generapdfordini', symbol:'task'}, ],
      fattureActions: [ {title: 'Genera Pdf No Linee', name:'generapdfnolinee', symbol:'task'}, {title: 'Genera Pdf', name:'generapdf', symbol:'task'}, ],
      headlineActions: [ {title: 'NikePad', name:'nikepad', symbol:''}, {title:'Dati', name:'liste', symbol:''}, {title: 'Assegni', name:'assegni', symbol:''}, {title:'Qualifica', name:'qualifica', symbol:''} ],
      timelineActions: [ {title: 'Nuovo Ticket', name:'ticket', symbol:''}, {name:'newtask', symbol:'', title:'Nuova Attività'}],
      quotazioniActions: [ {title: 'Genera Quotazione', name:'generaquotazione', symbol:'add'} ],
      sections:[],

      timeline: [],

      b2b: false,
      editTask: false,
      showAssegni: false,
      editTicket:false,
      showQualifica:false,

      dati: {
        Name:'',
        Codice_Subentro__c:'',
        Insegna__c:'',

        BillingStreet:'',
        BillingCity:'',
        BillingPostalcode:'',
        BillingState:'',

        Referente__c:'',
        Phone:'',
        Fax:'',
        Email__c:'',

        P_Iva__c:'',
        IBAN__c:'',
        Codice_Fatturazione_Elettronica__c:'',
        PEC__c:'',

        Spedire__c:'',
        ShippingStreet:'',
        ShippingCity:'',
        ShippingPostalcode:'',
        ShippingState:'',

        Referente_Consegne__c:'',
        Orari__c:'',

        Tipologia__c:'',
        Ubicazione__c:'',
        Contratto__c:'',
        Competitors__c:'',
        Description:''

      },
      filterPanel: {
        show: false,
        colIndex: null,
        colName: '',
        value: ''
        // show: false,
        // value:'',
        // name:'',
        // index:0,
        // filterCol: {}
      },
      documentiFilters: {}, 
      fattureFilters: {},
      mappaTooltips: {},

      showNewQuotazione: false,
      quotazioni: []
    };
  },
  watch: {
    '$route.params.id': function () {
      this.recordId=this.$route.params.id;
      this.record=this.$route.params.record;
      this.updateCustomer()
    }
  },
  mounted: function() {
    console.log("Email: "+this.$store.getters.connection.email);
    console.log("ID: "+this.$route.params.id);
    this.ticketfields=[];
    var t1={ id:1, title:'Destinatario', value:'', name:'Tipo', type:'picklist', placeholder:'Destinatario...', tabindex:1, disabled: false,
      options:[
        { label: 'Customer Service', value: 'Customer Service'},
        { label: 'Credito', value: 'Credito'},
      ]
    };
    this.ticketfields.push(t1);
    var f1={ id:2, title:'Oggetto', value:'', name:'Oggetto', type:'text', placeholder:'Oggetto...', tabindex:2, disabled: false};
    var f2={ id:3, title:'Descrizione', value:'', name:'Descrizione', type:'textarea', placeholder:'Descrizione...', tabindex:3, disabled: false};
    this.ticketfields.push(f1);
    this.ticketfields.push(f2);

    if (this.$store.state.connection.userdata.capoarea) {
      var f3={ id:4, title:'Informa Capoarea', value:'', name:'capoarea', type:'checkbox', placeholder:'Descrizione...', tabindex:4, disabled: false};
      this.ticketfields.push(f3);
    }

    if (!this.campagna) this.campagna=this.$store.state.campagne[0];
    this.recordId=this.$route.params.id;
    this.record=this.$route.params.record;
    this.setupHeaderFields();
    this.setupQueryFields();
    this.getLinee();
    this.updateCustomer();
//    this.getTicketsFd();
  },
  computed: {
    title: function() {
        if (this.record) 
          return this.record.Ragione_Sociale__c; // +' | '+this.record.Codice_2019__c;
        return '';
    },
    annocampagna: function() {
      return this.campagna.substr(0,4) || ''
    },
    tipocampagna: function() {
      return this.campagna.substr(5,2) || ''
    },
    filteredDocumenti: function() {
      if (Object.keys(this.documentiFilters).length === 0) {
        return this.documenti;
      }
      
      return this.documenti.filter(row => {
        for (const colName in this.documentiFilters) {
          const filterValue = this.documentiFilters[colName].toLowerCase();
          const cellValue = String(row[colName] || '').toLowerCase();
          
          if (cellValue.indexOf(filterValue) === -1) {
            return false;
          }
        }
        return true;
      });
    },
    filteredFatture: function() {
      if (Object.keys(this.fattureFilters).length === 0) {
        return this.fatture;
      }
      return this.fatture.filter(row => {
        for (const colName in this.fattureFilters) {
          const filterValue = this.fattureFilters[colName].toLowerCase();
          const cellValue = String(row[colName] || '').toLowerCase();
          if (cellValue.indexOf(filterValue) === -1) {
            return false;
          }
        }
        return true;
      });
    }
  },
  methods: {
    async deliveryTooltipData(datiDocumento){
      console.log("ricevuto dati documento: ", datiDocumento)
      const mapkey = datiDocumento.key;
      const record = datiDocumento.record
      let filtri = [
        { field: "N_Ordine__c", value: record.Documento },
        { field: "Codice_Articolo__c", value: record.Codice },
        { field: "Fattura__r.Account__c", value: record.Account },
      ]
      console.log("ho generato i filtri: ", filtri)
      const fatture = await this.getDatiFatture(filtri);
      // this.mappaTooltips[mapkey] = fatture
      // this.mappaTooltips={};
      this.$set(this.mappaTooltips, mapkey, fatture);
    },
    openDocumentiFilter(event) {
      const col = this.documenticols[event.index];
      this.documentiFilterPanel = {
        show: true,
        colIndex: event.index,
        colName: col.label,
        value: this.documentiFilters[col.name] || ''
      };
    },
    
    openFilterPanel(event, tableType) {
      let cols, filters;
      if (tableType === 'documenti') {
        cols = this.documenticols;
        filters = this.documentiFilters;
      } else if (tableType === 'fatture') {
        cols = this.fatturecols;
        filters = this.fattureFilters;
      } else {
        return;
      }

      const col = cols[event];
      this.filterPanel = {
        show: true,
        colIndex: event,
        colName: col.label,
        value: filters[col.name] || '',
        tableType: tableType
      };
    },
    openFilterPanelFatture(event) {
      const col = this.fatturecols[event];
      this.filterPanel = {
        show: true,
        colIndex: event,
        colName: col.label,
        value: this.fattureFilters[col.name] || '',
        table: 'fatture' // Identifica la tabella di destinazione
      };
    },
    applyFilter() {
      const colIndex = this.filterPanel.colIndex;
      const tableType = this.filterPanel.tableType;
      
      let cols, filters;
      if (tableType === 'documenti') {
        cols = this.documenticols;
        filters = this.documentiFilters;
      } else if (tableType === 'fatture') {
        cols = this.fatturecols;
        filters = this.fattureFilters;
      } else {
        this.filterPanel.show = false;
        return;
      }

      const col = cols[colIndex];
      if (this.filterPanel.value.trim()) {
        this.$set(filters, col.name, this.filterPanel.value);
      } else {
        this.$delete(filters, col.name);
      }
      
      this.filterPanel.show = false;
    },
  
    applyDocumentiFilter() {
      const colIndex = this.filterPanel.colIndex;
      const col = this.documenticols[colIndex];
      
      if (this.filterPanel.value.trim()) {
        this.$set(this.documentiFilters, col.name, this.filterPanel.value);
      } else {
        this.$delete(this.documentiFilters, col.name);
      }
      
      this.filterPanel.show = false;
    },
    
    filterDocumenti: function(event) {
      var col = this.documenticols[event.index];
      if (event.value) {
        this.$set(this.documentiFilters, col.name, event.value);
      } else {
        this.$delete(this.documentiFilters, col.name);
      }
    },
    doFilter: function() {
      var col=this.documenticols[this.filterPanel.index];
      col.filtered=this.filterPanel.value;
      this.filterPanel.show=false;
      this.getRecords();
    },
    filter: function(index) {
      console.log('filtertt');
      var col=this.documenticols[index];
      console.log('filtertt', col);
      if (col.filtered || true) {
        col.filtered=false;
        col.filterValue='';
        this.getRecords();
      } else {
        this.filterPanel.index=index;
        this.filterPanel.name=col.label;
        this.filterPanel.filterCol=col;
        this.filterPanel.value='';
        this.filterPanel.show=true;
      }
    },
    updateCustomer: function() {
      var self=this;
      this.getRecord().then(function() {

        if (self.record && self.record.B2B_Active__c) {
          self.timelineActions.unshift( {title: 'Attiva B2B', name:'b2b', symbol:''} );
        }

        self.getTimeline();

        self.setupOrdini();
        self.getOrdini();

        self.setupPartite();
        self.getPartite();

        self.setupFatture();
        self.getFatture();

        self.setupOrdiniDetail();
        self.getOrdiniDetail();

        self.getQuotazioni()

        self.setB2B()
        self.getB2BContacts()

        self.setupDocumenti();
        self.getOrdiniCompleti().then(function() {
          return self.getFattureComplete();
        }).then(function() {
          self.compilaDocumenti();
          console.log('finito');
        });
      });
    },
    fixObject: function() {
      var fok=[
        "Insegna__c",
        "Referente__c",
        "Phone",
        "Cellulare__c",
        "Fax",
        "Email__c",
        "Referente_Consegne__c",
        "Orari__c",
        "Tipologia__c",
        "Ubicazione__c",
        "Competitors__c",
        "Description"
      ];
      var o={};
      for (var f in this.dati) {
        if (this.dati[f] && fok.indexOf(f)>=0) o[f]=this.dati[f];
      }
      return o;
    },
    updateAccount: function() {
      console.log('createAccount')
      var mydata=this.fixObject();
      mydata.Data_Ultima_Modifica_da_Utente__c=new moment().format('YYYY-MM-DD')
      mydata.Utente__c=this.$store.state.user.email;
      //mydata.Id=this.recordId;
      console.log(mydata);
      this.busy=true;
      var self=this;
      apiclient.update(this.$store.getters.connection, 'Account', this.recordId, mydata).then(function(data) {
        self.showQualifica=false;
        self.busy=false;
        console.log(data);
      }).catch(function(err){
        self.showQualifica=false;
        self.busy=false;
        console.log(err);
      })
      
    },
    setDati: function(n) {
        this.dati[n]=this.record[n];
    },
    editAccount: function() {      
      this.showQualifica=true;

      this.setDati('Name');
      this.setDati('Codice_2019__c');
      this.setDati('FCP_ACCOUNTNUMSALESREP__c');
      this.setDati('CompanyIdHubspot__c');
      this.setDati('CompanyIdFreshdesk__c');
      this.setDati('Codice_Subentro__c');
      this.setDati('Insegna__c');

      this.setDati('BillingStreet');
      this.setDati('BillingCity');
      this.setDati('BillingPostalcode');
      this.setDati('BillingState');

      this.setDati('Referente__c');
      this.setDati('Phone');
      this.setDati('Cellulare__c');
      this.setDati('Fax');
      this.setDati('Email__c');

      this.setDati('P_Iva__c');
      this.setDati('IBAN__c');
      this.setDati('Codice_Fatturazione_Elettronica__c');
      this.setDati('PEC__c');

      this.setDati('Spedire__c');

      this.setDati('ShippingStreet');
      this.setDati('ShippingCity');
      this.setDati('ShippingPostalcode');
      this.setDati('ShippingState');

      this.setDati('Referente_Consegne__c');
      this.setDati('Orari__c');

      this.setDati('Tipologia__c');
      this.setDati('Ubicazione__c');
      this.setDati('Contratto__c');
      this.setDati('Competitors__c');
      this.setDati('Description');

    },
    setField: function(e) {
      console.log(e)
      var n=e.name;
      var v=e.value;
      var n2=n.substr(n.indexOf(".")+1)
      this.dati[n2]=v;
    },
    setTicketField: function(e) {
      var index=e.name;
      var value=e.value;
      console.log('setField:'+index+'='+value)
      this.ticketfields[index].value=value;
    },
    saveAssegni: function() {
      console.log('save assegni...');
      this.getTimeline();
      this.showAssegni=false;
    },
    saveB2B: function(event) {
      console.log(event);
      var body={ WhatId: this.recordId, Subject: 'modulo b2b a '+event.Email, Description: event.Descrizione, Utente__c: this.$store.state.user.email, Status: 'Completata', ActivityDate: new Date() };
      var self=this;
      apiclient.newTask(this.$store.getters.connection, body).then(function() {
        self.b2b=false;
        self.getTimeline();
      }).catch(function() {
        self.b2b=false;
      })

      console.log('updateAccount');
      var mydata={  };
      mydata.Data_Modulo_B2B__c=new moment().format('YYYY-MM-DD');
      mydata.Email_Modulo_B2B__c=event.Email;
      console.log(mydata);
      this.busy=true;
      apiclient.update(this.$store.getters.connection, 'Account', this.recordId, mydata).then(function(data) {
        self.busy=false;
        console.log(data);
      }).catch(function(err){
        self.busy=false;
        console.log(err);
      })
      
    },
    saveTask: function(event) {
      console.log(event);
      var body={ WhatId: this.recordId, Subject: event.Tipo, Causale__c: event.Causale, Description: event.Descrizione, Utente__c: this.$store.state.user.email, Status: 'Completata', ActivityDate: new Date() };
      var self=this;
      apiclient.newTask(this.$store.getters.connection, body).then(function() {
        self.editTask=false;
        self.getTimeline();
      }).catch(function() {
        self.editTask=false;
      })
    },
    saveTicket: function() {
      console.log('saveTicket')
      var self = this;
      this.editTicket=false;
      self.createTicketNew().then(function() {
        self.sendEmail();
        self.getTimeline();
      })
    },
    saveTicketFd: function() {
      var self = this;
      this.editTicket = false;
      self.createTicketNewFd().then(function() {
        console.log("Ticket saved!");
        try {
          self.sendEmail();
        }
        catch(err) {
          console.log(err)
        }
        self.getTimeline();
      });
    },
    actionClick: function(e) {
      console.log(e);
      switch (e) {
        case 'nikepad':
          window.open('fcpnike://order/customer/'+this.record.FCP_ACCOUNTNUMSALESREP__c,'_blank');          
        break;
        case 'liste':
          this.listmode=!this.listmode;
        break;
        case 'b2b':
          this.b2b=true;
        break;
        case 'newtask':
          this.editTask=true;
        break;
        case 'assegni':
          this.showAssegni=true;
        break;
        case 'ticket':
          if (this.record.CompanyIdHubspot__c)
            this.editTicket=true;
        break;
        case 'qualifica':
          this.editAccount();
        break;
        case 'generapdfordini':
          this.showpdfnolinee=false;
          this.showpdfordini=true;
        break;
        case 'generapdfordininolinee':
          this.showpdfnolinee=true;
          this.showpdfordini=true;
        break;
        case 'generapdf':
          this.showpdfnolinee=false;
          this.showpdf=true;
        break;
        case 'generapdfnolinee':
          this.showpdfnolinee=true;
          this.showpdf=true;
        break;
        case 'generaquotazione':
          console.log('ye')
          this.createQuote()
          break
        case 'test':
          this.sendEmail();
        break;
        case 'cedente':
          this.$router.push({ name:'CustomerForm', params: { id: this.record.FCP_PREVIOUSCUST__c, record: this.record } });
        break;
      }
    },
    click(e) {
      console.log(e)
      switch(e.attributes.type) {
        case 'Quote__c':
          this.$router.push( { name: 'Quotazione', params: { id: e.Id } } )
          break
      }
    },
    sendEmail: function() {
      var ticket={ Subject: this.ticketfields[1].value, Body: this.ticketfields[2].value}
      var view={ Account: this.record, Ticket: ticket, User: this.$store.state.user.email }
      view.ticketUrl='https://app.hubspot.com/contacts/7900902/ticket/'+this.ticketLastCreated.objectId;
      view.ticketObj=this.ticketLastCreated;

      console.log('view');
      console.log(view);
      var tmplSubject='Ticket da {{User}} su {{{ Account.Name }}}: {{ Ticket[0].value }}';
      var tmplBody='<h1>Agente: {{User}}</h1>';
      tmplBody+='<h3>Codice Zona: {{Account.Zona_2__c}}</h3>';
      tmplBody+='<h3>Codice Agente: {{Account.Zona_1__c}}</h3>';
      tmplBody+='<h1>Cliente: {{Account.Name}}</h1>';
      // tmplBody+='<h3>Link: <a href="{{ticketUrl}}">Clicca qui per vedere il ticket #{{ticketObj.objectId}}</a></h3>';
      tmplBody+='<h2>Oggetto: {{Ticket.Subject}}</h2>';
      tmplBody+='<p>{{Ticket.Body}}</p>';

      var to='ptorric@gnet.it'
      // if (this.record.Referente_CC__c) to=this.record.Referente_CC__c;
      // if (this.ticketfields[0].value=="Credito") to=this.record.Referente_CR__c;

      var email={
        from:'salespaddy@tsc4.com',
        to: [to],
        bcc: ['ptorric@gnet.it','ecornale@gnet.it'],
        subject: mustache.render(tmplSubject, view),
        htmlbody: mustache.render(tmplBody, view),
      }

      email.cc=[this.$store.state.user.email];

      if (this.$store.state.connection.userdata.capoarea) {
        if (this.ticketfields[3].value) {
          email.cc.push(this.$store.state.connection.userdata.capoarea);
        }
      }
      console.log('email');
      console.log(email);
      
      apiclient.notify(this.$store.getters.connection, email).then(function(res) {
        console.log(res);
      }).catch(function(err){
        console.log(err);        
      })
      
    },
    getRecord: function() {
      var self=this;
      return new Promise(function(resolve, reject) {
        var soql='select '+self.fieldsstring+' from Account where id=\''+self.recordId+'\' ';
        if (self.recordId.substring(0,3)!="001") { // non è un id salesforce
          soql='select '+self.fieldsstring+' from Account where Codice_2019__c=\''+self.recordId+'\' ';
        }
        console.log(soql);
        //this.busy=true;
        apiclient.query(self.$store.getters.connection, soql).then(function(data) {
          console.log('records:'+data.length);
          self.busy=false;
          self.record={};
          if (data.length>0) {
            self.record=data[0];
            self.recordId=data[0].Id;
            self.documentiActions.splice(0,1);
            if (self.record.FCP_PREVIOUSCUST__c) {
              self.documentiActions.push( {title: 'Vai a cedente', name:'cedente', symbol:'change_owner'} );
            }
          }
          self.updateRecordFields();
          resolve();
        }).catch(function(err){
          console.log(err);
          reject();
        })
      })
    },
    createTicketNew: function() {
      var self=this;
      return new Promise(function(resolve, reject) {
        var hsdata= [
          { "name": "subject", "value": self.ticketfields[1].value },
          { "name": "content", "value": self.ticketfields[2].value },
          { "name": "hs_pipeline", "value": "0" },
          { "name": "hs_pipeline_stage", "value": "1" }
        ];
        var referente=self.record.Referente_CC__c;
        if (self.ticketfields[0].value=="Credito") referente=self.record.Referente_CR__c;

        hsdata.push( { "name": "nome_cliente", "value": self.record.Ragione_Sociale__c } );
        hsdata.push( { "name": "codice_cliente", "value": self.record.Codice_2019__c } );

        console.log('apre un ticket con referente cc='+referente);
        if (referente=='ptorric@gnet.it') hsdata.push( { "name": "hubspot_owner_id", "value": "48654570" } ); // paolo
        if (referente=='ecornale@gnet.it') hsdata.push( { "name": "hubspot_owner_id", "value": "48900588" } ); // elena
        // credito
        if (referente=='gabriele.pellegrino@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179559" } );

        if (referente=='chiara.micheli@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179570" } );
        if (referente=='lidia.selleri@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179782" } );
        if (referente=='nicola.pettazzoni@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179578" } );

        // customer service
        if (referente=='raffaella.gamberini@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179378" } );

        if (referente=='carlotta.stegani@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "54197514" } );
        if (referente=='francesca.lepera@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179408" } );
        if (referente=='susanna.scarano@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "54197687" } );
        if (referente=='margherita.manfroi@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "54197685" } );
        if (referente=='giulia.priolo@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "54080383" } );
        if (referente=='elena.summo@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179381" } );
        if (referente=='barbara.manaresi@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "53179263" } );
        
        if (referente=='stefania.carrara@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "86870582" } );
        if (referente=='michela.bernardi@fcp.it') hsdata.push( { "name": "hubspot_owner_id", "value": "86871691" } );
      
        console.log('newTicket')
        console.log(hsdata);

        // resolve();
        apiclient.newTicket( self.$store.getters.connection, self.$store.getters.connection.userdata.hubspotId, self.record.CompanyIdHubspot__c, hsdata ).then(function(resp) {
          console.log(resp);
          self.ticketLastCreated=resp.data;
          resolve();
        }).catch(function(err) {
          reject(err);
        });
      });
    },
    //chiama il backend per creare un ticket
    createTicketNewFd: function() {
      var self = this;
      return new Promise(function(resolve, reject) {
        var payload = {
          email: self.$store.getters.connection.email,
          // email: 'ptorric@tsc4.com',
          subject: self.ticketfields[1].value,
          description: self.ticketfields[2].value,
          company_id: Number(self.record.CompanyIdFreshdesk__c),
          priority: 1,
          status: 2,
          type: self.ticketfields[0].value
        };

        if (self.ticketfields[3] && self.ticketfields[3].value) {
          payload.cc_emails=[];
          payload.cc_emails.push( self.$store.state.connection.userdata.capoarea );
        }

        if (payload.email=='ptorric@gnet.it') payload.email='ptorric@tsc4.com';

        var contactId = self.$store.getters.connection.userdata.contactId;

        console.log("creating new ticket freshdesk...:"+contactId);

        apiclient.newTicketFd(self.$store.getters.connection, payload, contactId).then(function(response) {
          console.log("new freshdesk ticket sent");
          console.log(response);
          resolve(response);
        }).catch(function(error) {
          console.log("error sending new ticket freshdesk");
          alert(JSON.stringify( error ));
          
          reject(error);
        });
      });
    },
    getOrdini: function() {
      var self=this;
      var fields="FCP_ITEMPRODUCTLINEID__c, Codice_Item__c, Descrizione_Item__c, avg(Prezzo_vendita__c) Prezzo_vendita__c, avg(Sconto__c) Sconto__c, sum(Quantita_ordinata__c) Quantita_ordinata__c, sum(Totale_Riga__c) Totale_Riga_Old__c, sum(Totale_Riga_Corretto__c) Totale_Riga__c, isGiusti__c";
      var soql='select '+fields+' from Riga_Ordine__c where ordine__r.Account__c=\''+this.recordId+'\' and ordine__r.isGiusti__c=false and ID_Campagna__c=\''+this.tipocampagna+'\' and FCP_COPYCMSYEAR__c=\''+this.annocampagna+'\' ';
      soql+=' group by isGiusti__c, FCP_ITEMPRODUCTLINEID__c, Codice_Item__c, Descrizione_Item__c order by FCP_ITEMPRODUCTLINEID__c, Descrizione_Item__c';
      console.log(soql);
      //this.busy=true;
      apiclient.query(this.$store.getters.connection, soql).then(function(data) {
        console.log('records:'+data.length);
        self.busy=false;
        self.ordini=data;
        self.updateRecordFields();
      }).catch(function(err){
        console.log(err);
      })
    },
    getPartite: function() {
      var self=this;
      var fields="Importo__c, Rif_Movimento__c, Fattura__r.Name, Data_Transazione__c, Data_Scadenza__c, Tipo_Pagamento_Saldo__c";
      var soql='select '+fields+' from Partita__c where Account__c=\''+this.recordId+'\'  ';
      soql+=' order by Data_Scadenza__c ';
      console.log(soql);
      //this.busy=true;
      apiclient.query(this.$store.getters.connection, soql).then(function(data) {
        console.log('records:'+data.length);
        self.busy=false;
        self.partite=data;
      }).catch(function(err){
        console.log(err);
      })
    },
    getB2BContacts: function() {
      var self=this;
      var fields="Id, Name, Email";
      var soql='SELECT '+fields+' FROM Contact WHERE AccountId = \''+this.recordId+'\' AND Shopify_Contact_Id__c != NULL ';
      soql+='';
      console.log(soql);
      apiclient.query(this.$store.getters.connection, soql).then(function(data) {
        console.log('records:'+data.length);
        self.busy=false;
        self.B2Bcontacts = data;
      }).catch(function(err){
        console.log(err);
      })
    },
    compilaFatture: function(records) {
        var campagna='', rcampagna={};
        var linea='', rlinea={};

        this.fatture.splice(0, this.fatture.length);
        records.forEach(function(r) {
          if (campagna!=r.FCP_COPYCMSCAMPAIGNID__c) {
            rcampagna={Codice_Articolo__c:r.FCP_COPYCMSCAMPAIGNID__c, Descrizione__c: '= = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = ', Totale:0, isbold:true };
            this.fatture.push(rcampagna);
            campagna=r.FCP_COPYCMSCAMPAIGNID__c;
          }
          if (linea!=r.FCP_ITEMPRODUCTLINEID__c) {
            var desclinea=this.linee.find(function(v) { return v.Name==r.FCP_ITEMPRODUCTLINEID__c; });
            var descrizione=(desclinea?desclinea.Descrizione__c:'');
            rlinea={Codice_Articolo__c:r.FCP_ITEMPRODUCTLINEID__c, Descrizione__c:descrizione, Totale:0, isbold:true};
            this.fatture.push(rlinea);
            linea=r.FCP_ITEMPRODUCTLINEID__c;
          }
          rcampagna.Totale+=r.Totale;
          rlinea.Totale+=r.Totale;
          r.FCP_COPYCMSCAMPAIGNID__c='';
          this.fatture.push(r);
        }, this);

    },
    compilaOrdini: function(records) {
        var campagna='', rcampagna={};
        var linea='', rlinea={};

        this.ordinidetail.splice(0, this.ordinidetail.length);
        records.forEach(function(r) {
          if (campagna!=r.ID_Campagna__c) {
            rcampagna={Codice_Item__c:r.ID_Campagna__c, Descrizione_Item__c: '= = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = ', Totale:0, isbold:true };
            this.ordinidetail.push(rcampagna);
            campagna=r.ID_Campagna__c;
          }
          if (linea!=r.FCP_ITEMPRODUCTLINEID__c) {
            var desclinea=this.linee.find(function(v) { return v.Name==r.FCP_ITEMPRODUCTLINEID__c; });
            var descrizione=(desclinea?desclinea.Descrizione__c:'');
            rlinea={Codice_Item__c:r.FCP_ITEMPRODUCTLINEID__c, Descrizione_Item__c:descrizione, Totale:0, isbold:true};
            this.ordinidetail.push(rlinea);
            linea=r.FCP_ITEMPRODUCTLINEID__c;
          }
          rcampagna.Totale+=r.Totale;
          rlinea.Totale+=r.Totale;
          r.ID_Campagna__c='';
          this.ordinidetail.push(r);
        }, this);

    },
    getLinee: function() {
      var self=this;
      var soql='select Name, Descrizione__c from Linea__c ';

      console.log(soql);
      this.busy=true;
      apiclient.query(this.$store.getters.connection, soql).then(function(data) {
        console.log('records:'+data.length);
        self.linee=data;
        self.busy=false;
      }).catch(function(err){
        console.log(err);
      })
    },
    getFatture: function() {
      var self=this;
      var fields=" Codice_Articolo__c, FCP_COPYCMSCAMPAIGNID__c, Descrizione__c, sum(Totale_netto__c) Totale, FCP_ITEMPRODUCTLINEID__c, sum(Quantita_Venduta__c) Quantita_Venduta, sum(Quantita_Omaggio__c) Quantita_Omaggio, sum(Quantita_Rese__c) Quantita_Rese, sum(Quantita_Totale__c) Quantita_Totale, avg(sconto__c) Sconto ";
      var soql='select '+fields+' from Riga_fattura__c where ';

      var campagneattive=[];
      this.filtrocampagneF.forEach(function(f,i) {
        if (f) campagneattive.push("'"+this.$store.state.campagne[i]+"'");
      }, this);
      if (campagneattive.length==0) campagneattive.push("'nessuna'");

      soql+=" AnnoCampagna__c in ("+campagneattive.join(',')+") ";
      soql+=" and Fattura__r.Account__c='"+this.recordId+"' ";
      soql+=" group by Codice_Articolo__c, FCP_COPYCMSCAMPAIGNID__c, Descrizione__c, FCP_ITEMPRODUCTLINEID__c ";
      soql+=" order by FCP_COPYCMSCAMPAIGNID__c, FCP_ITEMPRODUCTLINEID__c, Codice_Articolo__c ";
      console.log('🔎 '+soql);
      //this.busy=true;
      apiclient.query(this.$store.getters.connection, soql).then(function(data) {
        console.log('records:'+data.length);
        self.busy=false;
        self.compilaFatture(data);
//        self.fatture=data;
      }).catch(function(err){
        console.log(err);
      })
    },
    getOrdiniDetail: function() {
      var self=this;
      var fields=" Codice_Item__c, ID_Campagna__c, Descrizione_Item__c, sum(Totale_Riga_Corretto__c) Totale, FCP_ITEMPRODUCTLINEID__c, ";
      fields+=" sum(Calcolo_Quantita_Ordinata__c) Quantita_Ordinata, sum(Calcolo_Quantita_Omaggi__c) Quantita_Omaggio, sum(Calcolo_Quantita_Resa__c) Quantita_Rese, sum(Calcolo_Quantita_Annullata__c) Quantita_Annullata, sum(Calcolo_Quantita_Venduta__c) Quantita_Totale, avg(Sconto__c) Sconto ";
      var soql='select '+fields+' from Riga_Ordine__c where ';
      var campagneattive=[];
      this.filtrocampagneO.forEach(function(f,i) {
        if (f) campagneattive.push("'"+this.$store.state.campagne[i]+"'");
      }, this);
      if (campagneattive.length==0) campagneattive.push("'nessuna'");

      soql+=" AnnoCampagna__c in ("+campagneattive.join(',')+") ";
      soql+="and Ordine__r.Account__c='"+this.recordId+"' ";
      soql+=" group by Codice_Item__c, ID_Campagna__c, Descrizione_Item__c, FCP_ITEMPRODUCTLINEID__c ";
      soql+=" order by ID_Campagna__c, FCP_ITEMPRODUCTLINEID__c, Codice_Item__c ";
      console.log(soql);
      //this.busy=true;
      apiclient.query(this.$store.getters.connection, soql).then(function(data) {
        console.log('records:'+data.length);
        self.busy=false;
        self.compilaOrdini(data);
//        self.fatture=data;
      }).catch(function(err){
        console.log(err);
      })
    },
    getQuotazioni: function() {
      var self=this;
      var soql = 'SELECT '
      soql += Array.from(this.quotazionicols, c => c.name).join(', ')
      soql += ' FROM Quote__c'
      soql += " WHERE Account__c='"+this.recordId+"'"

      var campagneattive=[];
      this.filtrocampagneQ.forEach(function(f,i) {
        if (f) campagneattive.push("'"+this.$store.state.campagne[i]+"'");
      }, this);
      soql+=" order by CreatedDate DESC ";
      console.log('🔎 '+soql);

      apiclient.query(this.$store.getters.connection, soql)
      .then(function(data) {
        console.log('records:'+data.length);
        self.quotazioni = data
      }).catch(function(err){
        console.err('getQuotazioni', JSON.stringify(err))
      })
    },
    changeCampagna: function(index) {
      console.log('changeCampagna');
      console.log(index);
      this.campagna=this.$store.state.campagne[index];
      this.getOrdini();
    },
    changeCampagnaOrdini: function(index) {
      console.log('changeCampagnaOrdini');
      console.log(index);
      this.filtrocampagneO[index]=!this.filtrocampagneO[index];
      this.getOrdiniDetail();
    },
    changeCampagnaFatture: function(index) {
      console.log('changeCampagnaFatture');
      console.log(index);
      this.filtrocampagneF[index]=!this.filtrocampagneF[index];
      this.getFatture();
    },
    changeCampagnaQuotazioni: function(index) {
      console.log('changeCampagnaQuotazioni', index);
      this.filtrocampagneQ[index]=!this.filtrocampagneQ[index];
      this.getQuotazioni();
    },
    updateRecordFields: function() {
      // this.recordId=this.$route.params.id;
      // this.record=this.$route.params.record;
      console.log('actual record:');
      console.log(this.record);
      // header
      this.updateFieldsValue(this.headlineFields);
      // record
      this.campipartite.forEach(function(s) {
        this.updateFieldsValue(s.fields);
      }, this);
    },
    compilaDocumenti: function() {
      var levelKey='', levelRecord={};
      var dati=this.fattureComplete.concat(this.ordiniCompleti);
      dati.forEach((dato, index) => {
        dati[index] = {
          ...dati[index],
          tooltips: [{
            column: "Status",
            formula: {
              field: "Status",
              operator: "==",
              value:"Fatturato"
            }
          }]

        }
      });
      dati.sort(function(a,b) {
        if (a.timestamp==b.timestamp) {
          if (a.Tipo=='Ordine' && b.Tipo=='Fattura') return -1;
          if (a.Tipo=='Fattura' && b.Tipo=='Ordine') return 1;
          // return 0;
          return a.Riga<b.Riga;
        } else {
          return b.timestamp-a.timestamp;
        }
      });
      var lastadd=-2;
      var dati2=[];
      dati.forEach(function(r,i) {
        if (lastadd!=(i-1)) {
          if (levelKey!=r['Documento']) {
            var nr={ nRecord:0, sommaSconto:0, Totale:0, isbold:true, Id:r.custaccount,  Quantita:0, Sconto:0 };
            nr.Codice=r.Data;
            nr.Descrizione=r.Tipo+" "+r.Documento;
            if(r.Tipo == 'Fattura') nr.TotFattura=r.Importo;
            nr.Linea=r.Tipo2;
            levelRecord=nr;    

            nr.Documento=r.Documento,
            nr.Riga=r.Riga,
            nr.Data=r.Data,
            nr.Tipo=r.Tipo,

            dati.splice(i,0,levelRecord);
            dati2.push(levelRecord);
            levelKey=r['Documento'];
            lastadd=i;
          }
          levelRecord.nRecord+=1;
          levelRecord.Totale+=r.Totale;
          levelRecord.Quantita+=r.Quantita;

          if (r.Quantita) {
            levelRecord.sommaSconto+=r.Sconto/100*r.Totale;
            if (levelRecord.Quantita!=0)
              levelRecord.Sconto=levelRecord.sommaSconto/levelRecord.Totale*100;
          }
        }
      }, this);
      this.documenti=dati;     
      this.documentiFilters = {}; 
    },
    setupDocumenti: function() {
      var ord=1;
      this.documenticols.push( { order: ord++, value:'', label:'Codice', name:'Codice', type:'string' } );
      this.documenticols.push( { order: ord++, value:'TotFattura', label:'Descrizione', name:'Descrizione', type:'mix' } );
      this.documenticols.push( { order: ord++, value:'', label:'CC', name:'Campagna', type:'string' } );
      this.documenticols.push( { order: ord++, value:'', label:'Linea', name:'Linea', type:'string' } );
      this.documenticols.push( { order: ord++, value:'', label:'Qtà', name:'Quantita', type:'decimal' } );
      this.documenticols.push( { order: ord++, value:'', label:'Imp.Totale', name:'Totale', type:'currency' } );
      this.documenticols.push( { order: ord++, value:'', label:'Sc %', name:'Sconto', type:'decimal' } );
      this.documenticols.push( { order: ord++, value:'', label:'Status', name:'Status', type:'string' } );
    },
    getFattureComplete: function() {
      var self=this;
      return new Promise(function(resolve,reject) {
        var fields="Id, Name, Codice_Articolo__c, FCP_COPYCMSCAMPAIGNID__c, Descrizione__c, Totale_netto__c, FCP_ITEMPRODUCTLINEID__c, Quantita_Venduta__c, Sconto__c, ";
        fields+=" Fattura__r.Name, Fattura__r.Data_fattura_2__c, Fattura__r.Sales_type__c, Fattura__r.Tipo_Fattura__c, Fattura__r.Importo_Netto__c ";
        var soql='select '+fields+' from Riga_fattura__c where ';
        soql+="  Fattura__r.Data_fattura_2__c>=LAST_N_QUARTERS:5 ";
        // soql+=" and FCP_COPYCMSCAMPAIGNID__c in ('SC', 'PW')  ";
        soql+=" and Fattura__r.Account__c='"+self.recordId+"' ";
        soql+=" order by Fattura__r.Data_fattura_2__c desc, FCP_COPYCMSCAMPAIGNID__c, FCP_ITEMPRODUCTLINEID__c, Codice_Articolo__c ";
        console.log(soql);
        //self.busy=true;
        self.fattureComplete.splice(0,self.fattureComplete.length);
        apiclient.query(self.$store.getters.connection, soql).then(function(data) {
          console.log('records:'+data.length);
          if (data.length>0) {
            data.forEach(function(r) {
              var datedoc=new Date(r.Fattura__r.Data_fattura_2__c);
              var d={
                Id: r.Id,
                Documento: r.Fattura__r.Name,
                Riga: r.Name,
                Data: r.Fattura__r.Data_fattura_2__c,
                Importo: r.Fattura__r.Importo_Netto__c,
                Tipo: 'Fattura',
                Tipo2: r.Fattura__r.Tipo_Fattura__c,
                timestamp: datedoc.valueOf(),

                Codice: r.Codice_Articolo__c,
                Descrizione: r.Descrizione__c,
                Campagna: r.FCP_COPYCMSCAMPAIGNID__c,
                Linea: r.FCP_ITEMPRODUCTLINEID__c,
                Quantita: r.Quantita_Venduta__c,
                Totale: r.Totale_netto__c,
                Sconto: r.Sconto__c,
              }
              self.fattureComplete.push(d);
            })
          }
          self.busy=false;
          resolve();
        }).catch(function(err){
          console.log(err);
          reject(err);
        })
      });
    },
    getDatiFatture: async function(filtri){
      let soql = 'select Fattura__c,'
       +'MAX(Fattura__r.Name) Name,'
       +'MAX(Fattura__r.Account__c) Account__c,'
       +'MAX(Fattura__r.Codice_Articolo__c) Codice_Articolo__c,'
       +'MIN(Fattura__r.N_Fattura__c) N_Fattura__c,'
       +'MAX(Fattura__r.Data_Fattura__c) Data_Fattura__c,'
       +'MAX(Fattura__r.Data_fattura_2__c) Data_fattura_2__c,'
       +'MAX(Fattura__r.Quantita__c) Quantita__c,'
       +'COUNT(Id) TotalRows from Riga_fattura__c'
      if(filtri[0]){
        soql+=" where "
        
        filtri.forEach((filtro, index) => {
          if(index!=0) soql+= " and "
          soql += filtro.field + " = '" + filtro.value + "'"
        });
      }
      soql+= " group by Fattura__c"

      let data = await apiclient.query(this.$store.getters.connection, soql);

      return data.map(function(fattura){
        return [
          {
            label: "Numero",
            value: fattura.Name
          },
          {
            label: "Data",
            value: fattura.Data_fattura_2__c
          },
          /*
          {
            label: "Quantità",
            value: fattura.Quantita__c
          }
          */
        ]
      })
    },
    getOrdiniCompleti: function() {
      // this.getDatiFatture();
      var self=this;
      return new Promise(function(resolve,reject) {
        var fields=" Id, Name, Codice_Item__c, ID_Campagna__c, Descrizione_Item__c, Totale_Riga__c, Totale_Riga_Corretto__c, FCP_ITEMPRODUCTLINEID__c, Sconto__c, Quantita_ordinata__c, Stato_Ordine__c, ";
        fields+=" Ordine__r.Name, Ordine__r.Data_Ordine__c, Ordine__r.Stato_Ordine__c, Ordine__r.Tipo_Ordine__c, Ordine__r.Totale_Ordine__c, Ordine__r.Account__c ";
        var soql='select '+fields+' from Riga_Ordine__c where ordine__r.isGiusti__c=false and ';
        soql+=" Ordine__r.Data_Ordine__c>=LAST_N_QUARTERS:5  ";
        // soql+=" and ID_Campagna__c in ('SC', 'PW') ";
        soql+=" and Ordine__r.Account__c='"+self.recordId+"' ";
        soql+=" order by Ordine__r.Data_Ordine__c desc, ID_Campagna__c, FCP_ITEMPRODUCTLINEID__c, Codice_Item__c ";
        console.log(soql);
        self.ordiniCompleti.splice(0,self.ordiniCompleti.length);
        apiclient.query(self.$store.getters.connection, soql).then(function(data) {
          console.log('records:'+data.length);
          self.busy=false;
          if (data.length>0) {
            data.forEach(function(r) {
              var datedoc=new Date(r.Ordine__r.Data_Ordine__c);
              var d={
                Id: r.Id,
                Documento: r.Ordine__r.Name,
                Riga: r.Name,
                Data: r.Ordine__r.Data_Ordine__c,
                Importo: r.Ordine__r.Totale_Ordine__c,
                Account: r.Ordine__r.Account__c,
                Tipo: 'Ordine',
                Tipo2: r.Ordine__r.Tipo_Ordine__c,
                timestamp: datedoc.valueOf(),

                Codice: r.Codice_Item__c,
                Descrizione: r.Descrizione_Item__c,
                Linea: r.FCP_ITEMPRODUCTLINEID__c,
                Campagna: r.ID_Campagna__c,
                Quantita: r.Quantita_ordinata__c,
                Totale: r.Totale_Riga_Corretto__c,
                Sconto: r.Sconto__c,
                Status: r.Stato_Ordine__c
              }
              self.ordiniCompleti.push(d);
            })
          }
          resolve();
        }).catch(function(err){
          console.log(err);
          reject(err);
        })
      });
    },
    setupOrdini: function() {
      var ord=1;
      this.ordinicols.splice(0,this.ordinicols.length);
      this.ordinicols.push( { order: ord++, value:'', label:'Codice', name:'Codice_Item__c', type:'string' } );
      this.ordinicols.push( { order: ord++, value:'', label:'Linea', name:'FCP_ITEMPRODUCTLINEID__c', type:'string' } );
      this.ordinicols.push( { order: ord++, value:'', label:'Descrizione', name:'Descrizione_Item__c', type:'string' } );
      this.ordinicols.push( { order: ord++, value:'', label:'Prezzo M.', name:'Prezzo_vendita__c', type:'currency' } );
      this.ordinicols.push( { order: ord++, value:'', label:'%', name:'Sconto__c', type:'decimal' } );
      this.ordinicols.push( { order: ord++, value:'', label:'Qty', name:'Quantita_ordinata__c', type:'decimal' } );
      this.ordinicols.push( { order: ord++, value:'', label:'Totale', name:'Totale_Riga_Corretto__c', type:'currency' } );
      /*
      this.ordinicols.push( { order: ord++, value:'', label:'Ord.', name:'Totale_Riga__c', type:'currency' } );
      this.ordinicols.push( { order: ord++, value:'', label:'Fatt.', name:'Totale_Riga__c', type:'currency' } );
      this.ordinicols.push( { order: ord++, value:'', label:'Reso', name:'isGiusti__c', type:'decimal' } );
      */
    },
    setupPartite: function() {
      var ord=1;
      this.partitecols.splice(0,this.partitecols.length);
      this.partitecols.push( { order: ord++, value:'', label:'Data', name:'Data_Transazione__c', type:'date' } );
      this.partitecols.push( { order: ord++, value:'', label:'Fattura', name:'Fattura__r.Name', type:'string' } );
      this.partitecols.push( { order: ord++, value:'', label:'Rif.', name:'Rif_Movimento__c', type:'string' } );
      this.partitecols.push( { order: ord++, value:'', label:'Tipo Pag.', name:'Tipo_Pagamento_Saldo__c', type:'string' } );
      this.partitecols.push( { order: ord++, value:'', label:'Scadenza', name:'Data_Scadenza__c', type:'date' } );
      this.partitecols.push( { order: ord++, value:'', label:'Importo', name:'Importo__c', type:'currency' } );

      var itab=0;
      var sectionFields=[];
      sectionFields.push( { id:itab++, value:this.dati.Credito_Aperto__c, title:'Credito Aperto', name:'Credito_Aperto__c', type:'currency', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly} );
      sectionFields.push( { id:itab++, value:this.dati.N_Partite_Aperte__c, title:'N.Partite Aperte', name:'N_Partite_Aperte__c', type:'string', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly} );

      sectionFields.push( { id:itab++, value:this.dati.Credito_Futuro__c, title:'Credito Futuro', name:'Credito_Futuro__c', type:'currency', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly} );
      sectionFields.push( { id:itab++, value:this.dati.N_Partite_Future__c, title:'N.Partite Future', name:'N_Partite_Future__c', type:'string', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly} );

      sectionFields.push( { id:itab++, value:this.dati.Credito_Scaduto__c, title:'Credito Scaduto', name:'Credito_Scaduto__c', type:'currency', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly} );
      sectionFields.push( { id:itab++, value:this.dati.N_Partite_Scadute__c, title:'N.Partite Scadute', name:'N_Partite_Scadute__c', type:'string', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly} );

      sectionFields.push( { id:itab++, value:this.dati.Data_Primo_Credito_Scaduto__c, title:'Data Scaduto', name:'Data_Primo_Credito_Scaduto__c', type:'date', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly} );
      sectionFields.push( { id:itab++, value:this.dati.Data_Prossima_Scadenza__c, title:'Data Prossima Scad.', name:'Data_Prossima_Scadenza__c', type:'date', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly} );
      // sectionFields.push( { id:itab++, value:this.dati.Data_Ultimo_Credito_Scaduto__c, title:'Subentra a codice', name:'dati.Data_Ultimo_Credito_Scaduto__c', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly} );
      this.campipartite.splice(0,this.campipartite.length);
      this.campipartite.push( { order: 1, title: 'Situazione Credito', opened: this.listcredito, fields: sectionFields  });
    },
    setB2B() {
      var ord=1;
      this.B2Bcols.push( { order: ord++, value:'', label:'Nome', name:'Name', type:'string' } );
      this.B2Bcols.push( { order: ord++, value:'', label:'Email', name:'Email', type:'string' } );

      var itab=0;
      var sectionFields=[];
      sectionFields.push( { id:itab++, value:this.record.Stato_Attivazione_B2B__c, title:'Stato Attivazione B2B', name:'Stato_Attivazione_B2B__c', type:'string', placeholder:'', tabindex:itab++, disabled: true} );
      
      this.B2Bcampi.push( { order: 1, title: 'E-commerce', opened: this.b2bsection, fields: sectionFields  });
    },
    setupFatture: function() {
      var ord=1;
      this.fatturecols.splice(0,this.fatturecols.length);
      // this.fatturecols.push( { order: ord++, value:'', label:'CC', name:'FCP_COPYCMSCAMPAIGNID__c', type:'string' } );
      this.fatturecols.push( { order: ord++, value:'', label:'Codice', name:'Codice_Articolo__c', type:'string' } );
      this.fatturecols.push( { order: ord++, value:'', label:'Descrizione', name:'Descrizione__c', type:'string' } );
      this.fatturecols.push( { order: ord++, value:'', label:'Imp.Totale', name:'Totale', type:'currency' } );
      // this.fatturecols.push( { order: ord++, value:'', label:'Linea', name:'FCP_ITEMPRODUCTLINEID__c', type:'string' } );
      this.fatturecols.push( { order: ord++, value:'', label:'Ven.', name:'Quantita_Venduta', type:'decimal' } );
      this.fatturecols.push( { order: ord++, value:'', label:'Om.', name:'Quantita_Omaggio', type:'decimal' } );
      this.fatturecols.push( { order: ord++, value:'', label:'Rese', name:'Quantita_Rese', type:'decimal' } );
      this.fatturecols.push( { order: ord++, value:'', label:'Tot', name:'Quantita_Totale', type:'decimal' } );
      this.fatturecols.push( { order: ord++, value:'', label:'Sc %', name:'Sconto', type:'decimal' } );
    },
    setupOrdiniDetail: function() {
      var ord=1;      
      this.ordinidetailcols.splice(0,this.ordinidetailcols.length);
      // this.ordinidetailcols.push( { order: ord++, value:'', label:'CC', name:'FCP_COPYCMSCAMPAIGNID__c', type:'string' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Codice', name:'Codice_Item__c', type:'string' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Descrizione', name:'Descrizione_Item__c', type:'string' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Imp.Totale', name:'Totale', type:'currency' } );
      // this.ordinidetailcols.push( { order: ord++, value:'', label:'Linea', name:'FCP_ITEMPRODUCTLINEID__c', type:'string' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Ven.', name:'Quantita_Ordinata', type:'decimal' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Om.', name:'Quantita_Omaggio', type:'decimal' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Rese', name:'Quantita_Rese', type:'decimal' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Ann.', name:'Quantita_Annullata', type:'decimal' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Tot', name:'Quantita_Totale', type:'decimal' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Sc %', name:'Sconto', type:'decimal' } );
    },
    setupQueryFields: function() {
      var mfields=new Map();

      // id e name sempre
      mfields.set('Id', null);
      mfields.set('Name', null);
      mfields.set('Ragione_Sociale__c', null);
      mfields.set('Codice_2019__c', null);
      mfields.set('FCP_ACCOUNTNUMSALESREP__c', null);
      mfields.set('FCP_PREVIOUSCUST__c', null);
      
      mfields.set('Credito_Aperto__c', null);
      mfields.set('N_Partite_Aperte__c', null);
      mfields.set('Credito_Futuro__c', null);
      mfields.set('N_Partite_Future__c', null);
      mfields.set('Credito_Scaduto__c', null);
      mfields.set('N_Partite_Scadute__c', null);
      mfields.set('Data_Prossima_Scadenza__c', null);
      mfields.set('Data_Primo_Credito_Scaduto__c', null);

      mfields.set('CompanyIdHubspot__c', null);
      mfields.set('CompanyIdFreshdesk__c', null);
      mfields.set('Referente_CC__c', null);
      mfields.set('Referente_CR__c', null);
      mfields.set('Zona_1__c', null);
      mfields.set('Zona_2__c', null);
      mfields.set('Codice_Subentro__c', null);
      mfields.set('Insegna__c', null);

      mfields.set('BillingStreet', null);
      mfields.set('BillingCity', null);
      mfields.set('BillingPostalcode', null);
      mfields.set('BillingState', null);

      mfields.set('Referente__c', null);
      mfields.set('Phone', null);
      mfields.set('Cellulare__c', null);
      mfields.set('Fax', null);
      mfields.set('Email__c', null);

      mfields.set('P_Iva__c', null);
      mfields.set('IBAN__c', null);
      mfields.set('Codice_Fatturazione_Elettronica__c', null);
      mfields.set('PEC__c', null);

      mfields.set('Spedire__c', null);

      mfields.set('ShippingStreet', null);
      mfields.set('ShippingCity', null);
      mfields.set('ShippingPostalcode', null);
      mfields.set('ShippingState', null);

      mfields.set('Referente_Consegne__c', null);
      mfields.set('Orari__c', null);

      mfields.set('Tipologia__c', null);
      mfields.set('Ubicazione__c', null);
      mfields.set('Contratto__c', null);
      mfields.set('Competitors__c', null);
      mfields.set('Description', null);

      mfields.set('B2B_Active__c', null);
      mfields.set('Affiliazioni_Status__c', null);
      mfields.set('Stato_Attivazione_B2B__c', null);
            
      // header
      this.mapFields(mfields, this.headlineFields);
      // record
      this.sections.forEach(function(s) {
        this.mapFields(mfields, s.fields);
      },this);
      // riassume
      this.fields=this.uniqueFields(mfields);
      this.fieldsstring=this.fields.join(',');
    },
    setupHeaderFields: function() {
      this.headlineFields.splice(0,this.headlineFields.length);
      this.headlineFields.push( { value:'', label:'Codice', name:'Codice_2019__c', type:'string' } );
      this.headlineFields.push( { value:'', label:'Ultimo Ordine', name:'Data_Ultimo_Ordine_AX__c', type:'date' } );
      this.headlineFields.push( { value:'', label:'Ordini AC', name:'Totale_Ordinato_AX__c', type:'currency'} );
      this.headlineFields.push( { value:'', label:'Telefono', name:'Phone', type:'string'} );
      this.headlineFields.push( { value:'', label:'Email', name:'Email__c', type:'email' } );
      this.headlineFields.push( { value:'', label:'Affiliazioni', name:'Affiliazioni_Status__c', type:'string' } );
    },
    getTimeline: function() {
      var self=this;
      console.log('getting tasks')

      this.tickets=[];
      this.getTasks().then(function() {
        // console.log('tasks!')
        // return self.getTickets();
      // }).then(function() {
        console.log('fd tasks!')
        return self.getTicketsFd();
      }).then(function() {
        console.log('sorting')
        var data=[];
        data=self.tasks.concat(self.tickets);
        console.log('data:')
        console.log(data)
        console.log(self.tickets)
        console.log(self.tasks)
        data.sort(function(a, b) {
          a = new Date(a.ActivityDate);
          b = new Date(b.ActivityDate);
          return a>b ? -1 : a<b ? 1 : 0;
        });
        data.forEach(function(d) { d.show=false; });
        console.log('data:')
        console.log(data)

        self.timeline=data;
      })        
    },
    getTickets: function(){
      var self=this;
      return new Promise(function(resolve, reject) {
        // self.tickets=[];
        if (!self.record.CompanyIdHubspot__c) {
          resolve(self.tickets);
          return; 
        }
        console.log('chiede i ticket');
        console.log('id='+self.record.CompanyIdHubspot__c);
        apiclient.getTickets( self.$store.getters.connection, self.record.CompanyIdHubspot__c ).then(function(resp) {
        console.log('ticket ricevuti');
        console.log(resp.data);
          for (var t in resp.data) {
            var ticket=resp.data[t];
            console.log(ticket);
            var corpo;
            if (ticket.properties.content) corpo=ticket.properties.content.value;
            var stato=ticket.properties.hs_pipeline_stage.value;
            var soggetto;
            if (ticket.properties.subject) soggetto=ticket.properties.subject.value;
            var dataCreazione=moment(parseFloat(ticket.properties.createdate.timestamp)).format("YYYY-MM-DD");

            switch(stato) {
              case '0': stato = 'Assistenza'; break;
              case '1': stato = 'Nuovo'; break;
              case '2': stato = 'In Attesa Cliente'; break;
              case '3': stato = 'In Attesa'; break;
              default: stato = 'Chiuso'; break;
            }

            var o={ Subject: "["+stato+"] "+soggetto, Description:corpo, ActivityDate:dataCreazione, show: false, IsTask:true }
            self.tickets.push(o);
          }        
          resolve(self.tickets);
        }).catch(function(err) {
        console.log('ticket errore');
        console.log(err);
          reject();
        })
      })
    },
    getTicketsFd: function() {
      var self = this;
      return new Promise(function(resolve, reject) {
        // self.tickets = [];
        console.log("chiedo i ticket al backend");
        apiclient.getTicketsFd(self.$store.getters.connection, self.record.CompanyIdFreshdesk__c)
        .then(function(resp) {
          console.log("ticket ottenuti dal backend");
          console.log(resp.data);

          for (var t in resp.data) {
            var ticket=resp.data[t];
            console.log(ticket);
            var type;
            if (ticket.type) type=ticket.type;
            var corpo;
            if (ticket.description_text) corpo=ticket.description_text;
            var stato=ticket.status;
            var soggetto;
            if (ticket.subject) soggetto=ticket.subject;
            var dataCreazione=ticket.created_at.substr(0,10);

            switch(stato) {
              case 0: stato = 'Assistenza'; break;
              case 2: stato = 'Nuovo'; break;
              case 3: stato = 'In Attesa'; break;
              case 4: stato = 'Risolto'; break;
              case 5: stato = 'Chiuso'; break;
              case 6: stato = 'In Attesa Cliente'; break;
              case 7: stato = 'In Attesa Altri'; break;
              // default: stato = 'Chiuso'; break;
            }

            var o={ Subject: "["+stato+"] "+soggetto, Description:corpo, ActivityDate:dataCreazione, show: false, IsTask:true, Type: type }
            self.tickets.push(o);
          }        
          resolve(self.tickets);          
        })
        .catch(function(err) {
          console.error("errore nella ricezione dei ticket dal backend", err);
          reject(err);
        });
      });
    },
    getTasks: function() {
      var self=this;
      return new Promise(function(resolve, reject) {
        var soql='select Id, Subject, ActivityDate, Description, Utente__c, Type from Task where whatId=\''+self.recordId+'\' order by ActivityDate desc';
        apiclient.query(self.$store.getters.connection, soql).then(function(data) {
          console.log('records:'+data.length);
          data.forEach(function(d) { d.show=false; });
          self.tasks=data;
          resolve(self.tasks);
        }).catch(function(err){
          console.log(err);
          reject(err);
        })
      })
    },
    getRecords: function() {
      var self = this;
      // Resetta i filtri quando si ricaricano i dati
      this.documentiFilters = {};
      
      // ... il resto del tuo codice esistente per getRecords ...
      // (mantieni la tua logica esistente per il caricamento dei dati)
      
      // Esempio di chiamata API esistente
      var soql = 'select ...'; // La tua query SOQL
      apiclient.query(this.$store.getters.connection, soql).then(function(data) {
        // ... tua logica per processare i dati ...
        self.documenti = processedData; // Assicurati di assegnare i dati a this.documenti
        self.busy = false;
      }).catch(function(err) {
        console.log(err);
        self.busy = false;
      });


    },
    createQuote() {
      var record = {
        Account__c: this.recordId
      }
      apiclient.create(this.$store.getters.connection, 'Quote__c', record)
      .then(resp => {
        console.log('quote', resp)
        this.$router.push( { name: 'Quotazione', params: { id: resp.data.id } } )
      }).catch( e => {
        console.error(e);
      })

      // this.showNewQuotazione = true
          // this.$router.push( { name: 'Quotazione', params: '/' } );
    }

  }
}
</script>

<style scoped>
.bottonesplit {
    width: 0.75rem;
    background: white;
    border-radius: 0;
    border: 1px solid #dddbda;
}
</style>

